import { Domain, ExamMode, Track, type Domain as DomainType } from "./types";

export const QUESTION_BANK_VERSION = "2026.08.19.1";
export const PROGRESS_SCHEMA_VERSION = 1 as const;
export const PROGRESS_STORAGE_KEY = "edge-ready.progress.v1";

export const ResourceBudget = {
  MAX_PROGRESS_BYTES: 2 * 1024 * 1024,
  COMPREHENSIVE_QUESTION_COUNT: 40,
  TRACK_QUESTION_COUNT: 24,
  FOCUS_QUESTION_COUNT: 12,
  MAX_QUESTION_COUNT: 40,
} as const;

export const MasteryThreshold = {
  DEVELOPING_MINIMUM: 60,
  PROFICIENT_MINIMUM: 75,
  READY_MINIMUM: 85,
  READY_DOMAIN_MINIMUM: 80,
} as const;

export const APPLICATION_DOMAINS = [
  Domain.APP_FOUNDATIONS,
  Domain.ACCOUNT_DEFAULT_SECURITY,
  Domain.DNS_TLS,
  Domain.WAF_MANAGED_RULES,
  Domain.CUSTOM_RULES_LISTS,
  Domain.RATE_LIMITING_DDOS,
  Domain.API_BOT_SECURITY,
  Domain.ANALYTICS_TROUBLESHOOTING,
] as const satisfies readonly DomainType[];

export const ZERO_TRUST_DOMAINS = [
  Domain.ZERO_TRUST_FOUNDATIONS,
  Domain.IDENTITY_ENROLLMENT,
  Domain.CLIENT_DEVICE_POSTURE,
  Domain.TUNNELS_MESH_ROUTING,
  Domain.ACCESS_POLICIES,
  Domain.GATEWAY_POLICIES,
  Domain.TLS_DLP_CASB_ISOLATION,
  Domain.ZERO_TRUST_OPERATIONS,
] as const satisfies readonly DomainType[];

export const ALL_DOMAINS = [
  ...APPLICATION_DOMAINS,
  ...ZERO_TRUST_DOMAINS,
] as const satisfies readonly DomainType[];

export const TRACK_DOMAINS: Readonly<Record<Track, readonly DomainType[]>> = {
  [Track.APPLICATION_SECURITY]: APPLICATION_DOMAINS,
  [Track.ZERO_TRUST]: ZERO_TRUST_DOMAINS,
};

export const DOMAIN_LABELS: Readonly<Record<DomainType, string>> = {
  [Domain.APP_FOUNDATIONS]: "Application security foundations",
  [Domain.ACCOUNT_DEFAULT_SECURITY]: "Account and default security",
  [Domain.DNS_TLS]: "DNS and TLS",
  [Domain.WAF_MANAGED_RULES]: "WAF managed rules",
  [Domain.CUSTOM_RULES_LISTS]: "Custom rules and lists",
  [Domain.RATE_LIMITING_DDOS]: "Rate limiting and DDoS",
  [Domain.API_BOT_SECURITY]: "API and bot security",
  [Domain.ANALYTICS_TROUBLESHOOTING]: "Analytics and troubleshooting",
  [Domain.ZERO_TRUST_FOUNDATIONS]: "Zero Trust foundations",
  [Domain.IDENTITY_ENROLLMENT]: "Identity and enrollment",
  [Domain.CLIENT_DEVICE_POSTURE]: "Client and device posture",
  [Domain.TUNNELS_MESH_ROUTING]: "Tunnels, Mesh, and routing",
  [Domain.ACCESS_POLICIES]: "Access policies",
  [Domain.GATEWAY_POLICIES]: "Gateway policies",
  [Domain.TLS_DLP_CASB_ISOLATION]: "TLS inspection, DLP, CASB, and isolation",
  [Domain.ZERO_TRUST_OPERATIONS]: "Zero Trust operations",
};

export const MODE_LABELS: Readonly<Record<ExamMode, string>> = {
  [ExamMode.COMPREHENSIVE]: "Comprehensive diagnostic",
  [ExamMode.APPLICATION_SECURITY]: "Application Security diagnostic",
  [ExamMode.ZERO_TRUST]: "Zero Trust diagnostic",
  [ExamMode.FOCUS]: "Weak-area focus practice",
};
